/**
 * Criterion expenses note type
 */
export enum CriterionExpensesNoteType {
  CONSUMPTION = 1,
  THOUSANDTHS = 2,
  THOUSANDTHS_HEATING = 3,
}

/**
 * Type amount for expenses note
 */
export enum TypeAmount {
  VOLUNTARY = 1,
  INVOLUNTARY = 2,
  MANAGEMENT = 3,
}
